const SCOPE = 'kitchen'

export const isValidAccount = account =>
  account &&
  account.exp > account.iat &&
  account.scopes.find(scope => scope.includes(SCOPE))
